module.exports = __webpack_public_path__ + "img/reload.f6f20a06.svg";